// extracted by mini-css-extract-plugin
module.exports = {"stickyNavTopH":"50px","stickyNavBottomH":"60px","collapseTransitionDuration":"400ms"};